import React from 'react'
import ListReservations from './components/ListReservations'

const MyReservations = () => {
    return (
        <ListReservations />
    )
}

export default MyReservations
